'use strict';
const angular = require('angular');

export function RolesConfigService(SettingsService) {
  'ngInject';

  let ROLES_CONFIG = {};

  SettingsService.getByName({name: 'roles-and-permissions'}, setting => {
    ROLES_CONFIG = setting.data;

    // Public API here
    return {
      can(user, action) {

        return true;

        if (!user || !user.role || !user.role.length)
          return false;

        let roles = user.role;

        switch (action) {
          case "community.create":
            roles.forEach(role => {
              console.log(role);
              console.log(ROLES_CONFIG[role]);
              if (ROLES_CONFIG[role].community.create.length)
                return true;
            });
            return false;
            break;
          default:
            return false;
        }

      }
    };

  });
}


export default angular.module('conduu.RolesConfig', [])
  .factory('RolesConfig', RolesConfigService)
  .name;



// WEBPACK FOOTER //
// ./client/components/roles-config/roles-config.service.js